/* global _paq */
import React from 'react';
import ReactDom from 'react-dom';
import { selfTestInit, SelfTest, defaultTheme } from '@parsys/self_test';
import audioToneURL from 'UI/auto-test/assets/audio/tone.mp3';
import { captureException, initClientErrorTracking } from 'CLIENT/errorTracking';

window.renderApp = ({ relayServers, enableErrorTracking, enableMatomoTracking, version, supportPhoneNumber }) => {
  // We parse query string parameters to configure the app (flags are visible in browser console with the `help` command)
  const searchParams = new URLSearchParams(window.location.search);
  const backUrl = decodeURI(searchParams.get('backUrl') || '');
  const locale = decodeURI(searchParams.get('locale') || '');
  const verbose = decodeURI(searchParams.get('verbose')) !== 'null';
  window.help = `
list of supported URL parameters:
backUrl => any valid URL: specify a URL that the back button will navigate to once the test is complete. We add a 'success' param at the end with an error or success state (see constants.js)
showDetails => 'true' or 'false': verbose mode 
locale => 'en' or 'fr'
`;

  if (enableErrorTracking) {
    initClientErrorTracking(null, version);
  }

  if (enableMatomoTracking) {
    _paq.push(['trackPageView']);
  }

  // Test theme customization here
  const customTheme = {
    assets: {
      ...defaultTheme.assets,
      audioToneURL,
    },
  };

  selfTestInit({
    locale: locale || navigator.language.split('-')[0],
    relayServers,
    verbose,
    backUrl,
    localeStorageKey: 'rtc_ui_config',
    supportPhoneNumber,
    onUnhandledError: captureException,
    onTrackedClick: (...args) => _paq.push(['trackEvent', 'auto-test', ...args]),
    onTrackedResult: (checkLabel, value) => _paq.push(['trackEvent', 'auto-test', 'result', checkLabel, value]),
  });

  ReactDom.render(
    <SelfTest theme={customTheme} />,
    document.getElementById('app'),
  );
};
